import _ from 'underscore';
import React from 'react';

export const ValidationContext = React.createContext({
  notifyDataChange: _.noop,
});
